import { Component } from '@angular/core';

@Component({
  selector: 'lp-shared-lib',
  imports: [],
  templateUrl: './lexplus-shared-lib.html',
  styleUrl: './lexplus-shared-lib.css',
})
export class LexplusSharedLib {}
